import React from 'react';
import './sideBar.css'


export const Sidebar = () => {

  return (

    <div className='sidebar'>
    
    </div>

    
  )
}

export default Sidebar;